import DriveIndex from "@/views/Drive/index.vue";
import DriveAllVideos from "@/views/Drive/AllVideos.vue";
import DriveAllImages from "@/views/Drive/AllImages.vue";
import DriveAllFolders from "@/views/Drive/AllFolders.vue";
import AllFolderFiles from "@/views/Drive/FolderFiles.vue";
const DriveRoutes = [
  {
    path: "/drive-center",
    name: "DriveCenter",
    component: DriveIndex,
    meta: {
      title: "drive_center",
      description: "",
      auth: "auth",
      
      permissions: [
        "my-drive.create",
        "my-drive.read",
        "my-drive.update",
        "my-drive.delete",
      ],
    },
  },
  {
    path: "/drive-center/all-videos",
    name: "DriveCenterAllVideos",
    component: DriveAllVideos,
    meta: {
      title: "all_videos",
      description: "",
      auth: "auth",
      
      permissions: [
        "my-drive.create",
        "my-drive.read",
        "my-drive.update",
        "my-drive.delete",
      ],
    },
  },
  {
    path: "/drive-center/all-images",
    name: "DriveCenterAllImages",
    component: DriveAllImages,
    meta: {
      title: "all_images",
      description: "",
      
      auth: "auth",

      permissions: [
        "my-drive.create",
        "my-drive.read",
        "my-drive.update",
        "my-drive.delete",
      ],
    },
  },
  {
    path: "/drive-center/all-Folders",
    name: "DriveCenterAllFolders",
    component: DriveAllFolders,
    meta: {
      title: "all_folders",
      description: "",
      auth: "auth",
      permissions: [
        "my-drive.create",
        "my-drive.read",
        "my-drive.update",
        "my-drive.delete",
      ],
    },
  },
  {
    path: "/drive-center/folder/:folderId",
    name: "AllFolderFiles",
    component: AllFolderFiles,
    meta: {
      title: "all_folder_files",
      description: "",
      auth: "auth",
      permissions: [
        "my-drive.create",
        "my-drive.read",
        "my-drive.update",
        "my-drive.delete",
      ],
    },
  },
];

export default DriveRoutes;
